class SplideBlogPosts {
  constructor(selector, options) {
    this.itemNode = document.querySelector(selector);
    this.splide = new Splide(selector, options);
    this.paginationInfoContainer = document.querySelector('.blog-posts-section .js-pagination-info');

    this.updatePageInfo = this.updatePageInfo.bind(this);
  }

  init() {
    this.splide.mount();
    this.splide.on('moved', this.updatePageInfo);
    this.updatePageInfo();
  }

  updatePageInfo() {
    const totalItems = this.splide.length;
    const itemsPerPage = this.splide.options.perPage;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const currentPage = Math.ceil((this.splide.index + 1) / itemsPerPage);

    this.paginationInfoContainer.textContent = `${currentPage} / ${totalPages}`;
    if (totalItems === itemsPerPage) {
      this.itemNode.querySelector('.splide__arrows').style
      
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const slider = document.querySelector('#slider-blog-posts');
  const sliderSlides = slider.querySelectorAll('.blog-posts-item:not(.splide__slide--clone)').length;
  const desktopPerPage = 3;
  const mobilePerPage = 1;


  const splideBlogPosts = new SplideBlogPosts('#slider-blog-posts', {
    type: 'loop',
    perPage: desktopPerPage,
    rewind: true,
    pagination: true,
    gap: '30px',
    arrows: sliderSlides > desktopPerPage,
    breakpoints: {
      768: {
        perPage: mobilePerPage,
        arrows: sliderSlides > mobilePerPage
      },
    }
  });

  splideBlogPosts.init();
});
